import router from './../router'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5';

//import * as _ from '../util/tool'

// axios 配置
if(localStorage.authtoken!=undefined){
	axios.defaults.headers['x-auth-token'] = JSON.parse(localStorage.authtoken).token;
}
axios.defaults.timeout = 100000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

//本地需要打开下面配置地址（测试/正式环境不需要注释下面代码）
// axios.defaults.baseURL = 'http://mtest2.dzq.com';

//POST传参序列化
axios.interceptors.request.use((config) => {
    if(config.method  === 'post'){
      config.data = qs.stringify(config.data);
    }
    if(localStorage.authtoken!==undefined){
    	//config.headers.x-auth-token = gettoken();
    	if(config.headers['x-auth-token'] !== gettoken()){
    		config.headers['x-auth-token'] = gettoken();
    	}
    }
    return config;
},(error) =>{

    return Promise.reject(error);
});
//返回状态判断
axios.interceptors.response.use((res) =>{
    return res;
}, (error) => {
//  _.toast("网络异常", 'fail');
    return Promise.reject(error);
});
export function gettoken(){
	return JSON.parse(localStorage.authtoken).token;
}

export function fetchpost(url, params) {
    if(params != undefined){
      let sign=md5(objKeySort(params)).toUpperCase();
      Object.assign(params,{
        sign:sign
      })
    }
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
            if(response.data.resultCode==1){
                 resolve(response.data);
            }
            else{
                tokenerror(response.data)
                reject(response.data);
            }

            }, err => {
                reject(err);
            })
            .catch((error) => {
               reject(error)
            })
    })
}

export function fetchget(url) {
  if(url.split("?")[1] != undefined){
    let sendata = parseQueryString(url);
    let sign=md5(objKeySort(sendata)).toUpperCase();
    url= url+'&sign='+sign;
  }
    return new Promise((resolve, reject) => {
        axios.get(url)
            .then(response => {
            	if(response.data.resultCode==1){
                   resolve(response.data);
            	}
            	else{
                tokenerror(response.data);
            		if(response.data.resultCode != 1101){
                  reject(response.data);
                }
            	}
            }, err => {
                reject(err);
            })
            .catch((error) => {
               reject(error)
            })
    })
}
export function objKeySort(obj) { //排序的函数
	var item = Object.keys(obj).sort();　　
  let urldata = '';
  var val;
	for(var key in item) {
   val = obj[item[key]];
   console.log("val")
   console.log(val)
   console.log(item)
   if(item[key] == 'redirectUrl'){
     val = decodeURIComponent(val)
   }
   if(item[key] == 'sign'){
     continue;
   }
   if(item[key] == null){
    continue;
  }
   if(val == null || val.length==0 ){
     continue;
   }
   urldata += item[key] + '=' + val + '&';
 }
  // 正式环境
  // return urldata+"key=dsd289fas@#@W";
  // 测试环境
   return urldata+"key=" + process.env.KEY;
	//return urldata.substring(0, urldata.length - 1);
}
export function parseQueryString(url) {
	var str = url.split("?")[1], //通过?得到一个数组,取?后面的参数
		items = str.split("&"); //分割成数组
	var arr, name, value,newobj={};

	for(var i = 0; i < items.length; i++) {
		arr = items[i].split("="); //["key0", "0"]
		name = arr[0];
		value = arr[1];
		newobj[name]=value;
		//this[name] = value;
	}
	return newobj;
}
//token过期处理
const tokenerror = res =>{
  if(res.resultCode == 23){
    localStorage.removeItem('authtoken');
  }
	if(res.resultCode == 22){ //跳转第三方授权登录
    location.href = res.resultObj.oauthUri;
  }
// 1100 尚未登录
// 1101 登录超时
// 1102 刷新令牌
// 1103 账号锁定
  if(res.resultCode === 1101 || res.resultCode === 1100 || res.resultCode === 1102) {
    localStorage.removeItem('authtoken');
    router.app._route.query.shopAlias?
    router.push({
          path: '/user/login',
          query: {
            shopAlias: router.app._route.query.shopAlias,
          }
    })
    :
    router.push({
          path: '/user/login'
    })
  }
}
export default {
    //商家登录预览 -- app 预览
    appview(data){
        return fetchpost('/wap/app-review-login',data)
    },
    //店铺信息
    getShopInfo(data){
      // alert(JSON.stringify(data))
    	return fetchget('/wap/shop/get-shop-info?'+data)
    },
    //店铺资料-获取全部营业网点信息列表
    listShopSite(data){
    	return fetchget('/wap/shop/site/list-shop-site?'+data)
    },
    //店铺优惠券
    shopticketlist(data){
    	return fetchget('/wap/ticket/voucher/index-list-data?'+data)
    },
    //收藏
    collection(data) {
      return fetchpost('/wap/shop/attention/attention-shop', data)
    },
    //取消收藏
    cancelcollection(data) {
      return fetchpost('/wap/shop/attention/cancel-attention-shop', data)
    },
    //商品推荐
    recommend(data){
      return fetchget('/wap/income/goods/recommend-goods-list?'+data);
    },
    //添加访问记录
    addmembervisitlog(data){
      return fetchpost('/wap/member/add-member-visit-log',data)
    },
    //登录
    login(data){
    	return fetchpost('/wap/login',data)
    },
    // 授权登录
    authlogin(data){
    	return fetchget('/wap/auth-login?'+data)
    },
    //手机验证码
    phonemethods(data){
      return fetchpost('/wap/authcode/sendMes',data)
    },
    //验证手机号码
    checkphone(data){
      return fetchpost('/wap/pay-center/check-phone',data);
    },
    //手机号码校验是否注册
    hadregiestcasher(phone){
      return fetchget('/wap/shop/had-regiest-casher?phone='+phone)
    },
     //优惠券详情
     ticketdetail(data){
    	return fetchget('/wap/ticket/voucher/get-detail?'+data)
    },
    //获取优惠券
    getticket(data){
    	return fetchpost('/wap/ticket/voucher/take-ticket',data)
    },
    //用户同步微信卡券-H5领取卡券参数获取
    getWechatcardParams(data){
    	return fetchget('/wap/ticket/voucher/get-wechatcard-params?'+data)
    },
    //会员同步微信卡券结果，更新优惠券订单表
    updateMemSyncStatus(data){
    	return fetchpost('/wap/ticket/voucher/update-mem-sync-status',data)
    },
    //更新会员卡包微信同步状态
    updatePackSyncStatus(data){
    	return fetchpost('/wap/member/pack/update-sync-status',data)
    },
    //商品详情
    goodsDetail(data){
      return fetchget('/wap/income/goods/goods-detail?'+data);
    },
    //商品搜索
    searchgoods(data){
      return fetchget('/wap/income/goods/find-goods-by-name?'+data);
    },
    //获取外卖时间设置
    takeoutset(data){
    	return fetchget('/wap/goods/order/get-shop-takeoutset?'+data)
    },
    //获取购物车数量
    countshopcart(data){
      return fetchget('/wap/shopcart/count-shopcart?'+data);
    },
    //增加或减少购物车商品数量
    shopcart(data){
      return fetchpost('/wap/shopcart/add-or-sub-shopcart',data);
    },
    //购物车列表
    shopCartList(data){
      return fetchget('/wap/shopcart/shopcart-list?'+data);
    },
    //删除购物车商品
    delShopCart(data){
      return fetchpost('/wap/shopcart/delete-shopcart',data);
    },
    //个人中心
    userindex(data){
      return fetchget('/wap/shop/personal-center/index?'+data)
    },
     //订单列表
    orderlist(data){
      return fetchget('/wap/goods/order/mem-order-list?'+data)
    },
    //订单详情
    orderdetail(data){
      return fetchget('/wap/goods/order/get-goods-order?'+data)
    },
    //确认收货
    confirmpickUp(data){
    	return fetchpost('/wap/goods/order/confirm-pickup',data)
    },
    //取消订单
    ordercancel(data){
      return fetchpost('/wap/goods/order/cancel-order',data)
    },
    //用户优惠券列表
    userticket(data){
      return fetchget('/wap/ticket/voucher/list-data?'+data)
    },
    //我的足迹
    footPrint(data){
    	return fetchget('/wap/shop/personal-center/my-foot-print?'+data)
    },
    //我的收藏
    collectionlist(data){
    	return fetchget('/wap/shop/attention/list-attention-shop?'+data)
    },
    //礼品列表
    giftlist(data){
    	return fetchget('/wap/ticket/gift/list-data?'+data)
    },
    //礼品详情
    giftdetail(data){
    	return fetchget('/wap/ticket/gift/get-detail?'+data)
    },
    //礼品兑换
    checkgift(data){
    	return fetchpost('/wap/ticket/gift/check-gift',data)
    },
    //领取礼品
    takeGift(data){
    	return fetchpost('/wap/ticket/gift/take-gift',data)
    },
    //商品列表
    goodlist(data){
    	return fetchget('/wap/income/goods/list-cate-cgoods-info?'+data)
    },
    //地址列表
    addresslist(){
    	return fetchget('/wap/member/contact/list-data')
    },
    //添加地址
    addaddress(data){
    	return fetchpost('/wap/member/contact/add-contact-info',data)
    },
    //修改地址
    editaddress(data){
    	return fetchpost('/wap/member/contact/edit-contact-info',data)
    },
    //删除地址
    deleteaddress(data){
    	return fetchpost('/wap/member/contact/delete-contact-info',data)
    },
    //设为默认地址
    setselectadd(data){
    	return fetchpost('/wap/member/contact/change-default-contact',data)
    },
    //查询店铺网点列表和用户使用网点，未设置默认取第一条
    memberShopSite(data){
    	return fetchget('/wap/goods/order/member-shop-site?'+data)
    },
    // 设置用户使用店铺网点
    setMemberShopSite(data){
    	return fetchpost('/wap/goods/order/set-member-shop-site',data)
    },
    //下单优惠列表
    shopdiscount(data){
    	return fetchget('/wap/goods/order/get-discount-info?'+data)
    },
    //确认下单接口
    makeorder(data){
    	return fetchget('/wap/goods/order/order-confirm?'+data)
    },
    //下单接口
    order(data){
      // alert(JSON.stringify(data))
    	return fetchpost('/wap/goods/order/add-goods-order',data)
    },
    //获取订单信息
    ordertopay(data){
    	return fetchget('/wap/goods/order/to-pay-view?'+data)
    },
    //下预支付订单
    gopay(data){
      // alert(JSON.stringify(data))
        return fetchpost('/wap/pay-center/takeOut-prePay',data)
    },
    //货到付款
    takeoutdeliverypay(data){
      return fetchpost('/wap/pay-center/takeout-delivery-pay',data);
    },
    //储值卡支付
    storagePay(data){
      return fetchpost('/wap/pay-center/goods/store-pay',data);
    },
    //添加收银员
    addshopcashier(data){
      return fetchpost('/wap/shop/add-shop-cashier',data)
    },
    //登录收银员
    loginshopcashier(data){
      return fetchpost('/wap/shop/cashier-login',data)
    },
    //修改密码
    cashierforgetpassword(data){
      return fetchpost('/wap/shop/cashier-forget-password',data)
    },
    //app调用优惠券规则页(京东)
    listCouponAll(){
      return fetchget('/wap/h5/coupon/list-coupon-all')
    },
    //app调用协议页面
    inputbusiness(data){
      return fetchget('/wap/bankpic/business/input-business?'+data)
    },
    //app调用协议页面
    inputbusiness10(data){
      return fetchget('/wap/bankpic/business/input-business?'+data)
    },
    //app调用详情
    schoolArticleDetail(data){
      return fetchget('/wap/article/article-detail?'+data)
    },
    //获取店铺服务套餐的权限信息
    getShopMenueResource(data){
      return fetchget('/wap/product/scheme/get-shop-menue-resource?'+data)
    },
    //店铺-获取店铺装饰模板信息接口
    getshopStyleData(data){
      return fetchget('/wap/shopstyle/v2/shop-style-data?'+data)
    },
    //获取会员信息、等级信息
    memberInfo(data){
      return fetchget('/wap/member/mainpage/member-info?'+data)
    },
    //获取会员信息、等级信息
    memberStoreInfo(data){
      return fetchget('/wap/member/mainpage/shop-store-info?'+data)
    },
    //会员主页--获取店铺会员折扣信息列表
    shopDiscountCardList(data){
      return fetchget('/wap/member/mainpage/shop-discount-card-list?'+data)
    },
    //会员主页--获取特别福利信息列表
    shopCountNumList(data){
      return fetchget('/wap/member/mainpage/shop-count-num-list?'+data)
    },
    //会员主页--获取积分礼品信息列表
    shopPointGift(data){
      return fetchget('/wap/member/mainpage/shop-point-gift-page?'+data)
    },
    //会员主页--获取积分礼品信息列表
    helpTypeList(data){
      return fetchget('/wap/article/help-type-list?'+data)
    },
    //会员主页--获取积分礼品信息列表
    helpArticleDetail(data){
      return fetchget('/wap/article/help-article-detail?'+data)
    },
    //会员主页--获取积分礼品信息列表
    shopMemberPointAccount(data){
      return fetchget('/wap/point/shop-member-point-account?'+data)
    },
    //会员主页--获取积分礼品信息列表
    shopMemberPointLogList(data){
      return fetchget('/wap/point/shop-member-point-log-list?'+data)
    },
    //成为会员发送短信验证码
    sendJoinMemberCheckMsg(data){
      return fetchpost('/wap/authcode/send-join-member-check-msg',data)
    },
    //成为会员--会员绑定手机号信息提交
    joinShopMember(data){
      return fetchpost('/wap/member/join-shop-member',data)
    },
    //会员储值--获取会员储值卡详细信息接口
    storeAccountInfo(data){
      return fetchget('/wap/pack/store/store-account-info?'+data)
    },
    //会员储值--获取储值卡账户明细
    getMemberStoreDetail(data){
      return fetchget('/wap/pack/store/get-member-store-detail?'+data)
    },
    //会员储值--提交储值卡充值支付订单接口
    rechargeStoreCard(data){
      return fetchpost('/wap/pack/store/recharge-store-card',data)
    },
    //会员储值--储值优惠明细
    findStoreDiscountDetail(data){
      return fetchpost('/wap/pack/store/find-store-discount-detail',data)
    },
    //会员储值--提交储值卡充值支付订单接口
    storeCardFillPrePay(data){
      return fetchpost('/wap/pack/store/store-card-fill-prePay',data)
    },
    //会员储值--提交储值卡充值支付订单接口
    generateStoreOrder(data){
      return fetchpost('/wap/pack/store/generate-store-order',data)
    },
    //会员体系
    getShopMemSystem(data){
      return fetchget('/wap/shop/get-shop-memSystem?' + data)
    },
    // 获取储值卡充值后详情
    getMemberStoreBalance(data){
      return fetchget('/wap/pack/store/get-member-store-balance?'+data)
    },
    // 获取计次卡详情
    getCountNumCardInfo(data){
      return fetchget('/wap/countNumCard/get-countNumCard-info?'+data)
    },
    // 获取折扣卡详情
    getDiscountCardInfo(data){
      return fetchget('/wap/discountCard/get-discountCard-info?'+data)
    },
    // 计次卡领取
    takeCountCard(data){
      return fetchpost('/wap/countNumCard/take-countCard',data)
    },
    // 折扣卡领取
    takeDiscountCard(data){
      return fetchpost('/wap/discountCard/take-discountCard',data)
    },
    // 生成购买计次卡订单
    generateCountOrder(data){
      return fetchpost('/wap/countNumCard/generate-count-order',data)
    },
    // 生成购买折扣卡订单
    generateDiscountOrder(data){
      return fetchpost('/wap/discountCard/generate-discount-order',data)
    },
    // 提交计次卡卡购买预支付订单接口
    countNumCardPrePay(data){
      return fetchpost('/wap/pay-center/countNumCard-prePay',data)
    },
    // 提交折扣卡购买预支付订单接口
    discountCardPrePay(data){
      return fetchpost('/wap/pay-center/discountCard-prePay',data)
    },
    // 获取折扣卡订单状态
    discountTradeHadPay(data){
      return fetchget('/wap/discountCard/discountTrade-hadPay?'+data)
    },
    // 获取计次卡订单状态
    countTradeHadPay(data){
      return fetchget('/wap/countNumCard/countTrade-hadPay?'+data)
    },
    // 获取会员卡包列表
    cardPackList(data){
      return fetchget('/wap/member/pack/cardPack-list?'+data)
    },
    // 获取卡包详情
    packRightList(data){
      return fetchget('/wap/member/pack/packRight-list?'+data)
    },
    // 使用卡包获取动态卡号
    getDynamicNo(data){
      return fetchget('/wap/member/pack/get-dynamic-no?'+data)
    },
    // 删除卡包
    deleteCardPack(data){
      return fetchpost('/wap/member/pack/delete-cardPack',data)
    },
    // 会员消费记录
    consumeList(data){
      return fetchget('/wap/member/consume-list?'+data)
    },
    // 会员消费详情
    consumeDetail(data){
      return fetchget('/wap/member/consume-detail?'+data)
    },
    // 我的账户
    accountCenter(){
      return fetchget('/wap/member/account-center')
    },
    // 更新会员昵称
    updateNickname(data){
      return fetchpost('/wap/member/update-nickname',data)
    },
    // 我的账户-会员用户绑定手机号
    combineWithPhone(data){
      return fetchpost('/wap/member/combine/combine-with-phone',data)
    },
    // 我的账户-会员用户解绑并强制绑定手机号
    combineWithPhoneForce(data){
      return fetchpost('/wap/member/combine/combine-with-phone-force',data)
    },
    // 我的账户-绑定支付宝账号
    combineWithAlipay(data){
      return fetchpost('/wap/member/combine/combine-with-alipay',data)
    },
    // 我的账户-解绑支付宝账号
    undoCombineWithAlipay(data){
      return fetchpost('/wap/member/combine/undo-combine-with-alipay',data)
    },
    // 我的账户-解绑并强制绑定支付宝账号
    combineWithAlipayForce(data){
      return fetchpost('/wap/member/combine/combine-with-alipay-force',data)
    },
    // 我的账户-绑定微信账号
    combineWithWechat(data){
      return fetchpost('/wap/member/combine/combine-with-wechat',data)
    },
    // 我的账户-解绑微信账号
    undoCombineWithWechat(data){
      return fetchpost('/wap/member/combine/undo-combine-with-wechat',data)
    },
    // 我的账户-解绑并强制绑定微信账号
    combineWithWechatForce(data){
      return fetchpost('/wap/member/combine/combine-with-wechat-force',data)
    },
    // 请求第三方平台账号授权绑定跳转
    authCombine(data){
      return fetchget('/wap/auth-combine?'+data)
    },
    // 查询邀请成为店铺管理员详情
    getShopInviteManager(data){
      return fetchget('/wap/shop/get-shop-invite-manager?'+data)
    },
    //微信分享
    wxshare(data){
      return fetchpost('/wap/weixin/share',data);
    },
    //订单可支付校验
    canPayJudge(data){
      return fetchpost('/wap/pay-center/goods/can-pay-judge',data);
    },

    // 博饼
    //表单防重复提交
    getToken(){
      return fetchget('/wap/formToken/getToken');
    },
    //查询博饼活动列表
    getDiceEntry(data){
      return fetchget('/wap/activity/dice/get-dice-entry?'+data);
    },
    //查询博饼活动列表
    listShakeDice(data){
      return fetchget('/wap/activity/dice/list-shake-dice?'+data);
    },
    //查询博饼活动详情
    getShakeDiceDetail(data){
      return fetchget('/wap/activity/dice/get-shake-dice-detail?'+data);
    },
    //博饼活动分享成功
    shareShakeDiceActivity(data){
      return fetchpost('/wap/activity/dice/share-shake-dice-activity',data);
    },
    //博饼摇色子
    shakeDice(data){
      // alert(JSON.stringify(data))
      return fetchpost('/wap/activity/dice/shake-dice',data);
    },
    //跑马灯-最新活动中奖翻页列表
    getLastWinning(data){
      return fetchget('/wap/activity/dice/get-last-winning?'+data);
    },
    //博饼-我的中奖纪录
    getMyWinning(data){
      return fetchget('/wap/activity/dice/get-my-winning?'+data);
    },
    // 博饼 End


}




// WEBPACK FOOTER //
// ./src/fetch/api.js